import apiFetch from '../../apiFetch'

export default function (token) {
  return apiFetch({endPoint: `Bioseguridad`, method: 'GET', body: null, token: token})
}
